import { Module } from 'vuex'
import { userData } from '@/requests/user'

const state = {
  userData: null as any,
}

const user: Module<typeof state, any> = {
  namespaced: true,
  state() {
    return state
  },
  getters: {
    permissions(state): string[] {
      return state.userData?.permissions || []
    },
    // Перевіряє чи має поточний користувач конкретний permission
    can: (_state, getters) => {
      return (permission: string): boolean => {
        return getters.permissions.includes(permission)
      }
    },
    // Перевіряє чи має поточний користувач хоча б один з permissions
    canAny: (_state, getters) => {
      return (permissions: string[]): boolean => {
        return permissions.some(p => getters.permissions.includes(p))
      }
    },
    // Перевіряє доступ до групи ресурсу (будь-який permission що починається з prefix)
    canAccessResource: (_state, getters) => {
      return (resource: string): boolean => {
        return getters.permissions.some((p: any) =>
          p.startsWith(resource + '.')
        )
      }
    },
  },
  mutations: {
    setUserData(state, userData) {
      state.userData = userData
    },
  },
  actions: {
    getUserData({ commit }) {
      return userData().then(res => {
        commit('setUserData', res)
        return res
      })
    },
  },
}

export { user }
